import { Outlet } from 'react-router-dom';
import DocsSidebar from './DocsSidebar';
import './documentation.css';

export default function Documentation() {
  return (
    <div className="documentation">
      <aside>
        <DocsSidebar />
      </aside>
      <main>
        <Outlet />
      </main>
    </div>
  );
}
